import React, { FC, useEffect, useState } from 'react';
import Profile from '../Icons/Profile/Profile';
import styles from './header.module.css';
import { setView } from '../../store/reducers/ViewSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';

import NavMenuButton from '../Buttons/navMenuButton/NavMenuButton';
import Log from '../Icons/Log/Log';
import Settings from '../Icons/Settings/Settings';
import Wallet from '../Icons/Wallet/Wallet';
import ArrowBottomIcon from '../Icons/ArrowBottom/ArrowBottomIcon';
import BalanceButton from '../Buttons/balanceButton/BalanceButton';
import {
	setBalanceModal,
	setSettingsModal,
	setSettingsProfileModal,
} from '../../store/reducers/ModalSlice';
import { setDataPage } from '../../store/reducers/PagesSlice';
import GetterIcon from '../Icons/Getter/GetterIcon';
import Play from '../Icons/Play/Play';
import Counter from '../Icons/Counter/Counter';
import LinksServices from '../LinksServices/LinksServices';
import { getStatFromSpeech } from '../../service/UsersService';
import LogoutButton from '../LogoutButton/LogoutButton';

const Header: FC = () => {
	const dispatch = useAppDispatch();
	const { profile } = useAppSelector((state) => state.profileReducer);
	const page = useAppSelector((state) => state.pagesReducer);
	
	const [seconds, setSeconds] = useState<number | string>('');
	const returnSeconds = async () => {
		if (profile?.recognize_key != 'getter') {
			const response = await getStatFromSpeech(profile!.recognize_key!);
			if (response.error) {
				setSeconds('');
			} else {
				const { timeLeft } = response.data.data;
				setSeconds(timeLeft);
			}
		}
	};

	useEffect(() => {
		returnSeconds();
		returnBalanceTariff();
	}, []);

	const returnBalanceTariff = () => {
		if (
			profile &&
			`balance_getter_advanced` in profile &&
			profile?.tariff === 'advanced'
		) {
			// @ts-ignore
			return `${Math.ceil(profile.balance_getter_advanced / 60)}`;
		} else if (
			profile &&
			`balance_getter_basic` in profile &&
			profile?.tariff === 'basic'
		) {
			// @ts-ignore
			return `${Math.ceil(profile!.balance_getter_basic / 60)}`;
		} else if (profile && `balance_getter_test` in profile) {
			// @ts-ignore
			return `${Math.ceil(profile!.balance_getter_test / 60)}`;
		} else {
			return `0`;
		}
	};

	const onSetViewMeters = (text: string) => {
		if (text !== page.data) {
			dispatch(setDataPage(text));
			dispatch(setView('meters'));
		}
	};

	const onSetViewCalls = (text: string) => {
		if (text !== page.data) {
			dispatch(setDataPage(text));
			dispatch(setView('calls'));
		}
	};

	const showSettingsModal = (text: string) => {
		if (text !== page.data) {
			dispatch(
				setSettingsModal({
					show: true,
				})
			);
			dispatch(setDataPage(text));
		}
	};

	const showSettingsProfileModal = (text: string) => {
		if (text !== page.data) {
			dispatch(
				setSettingsProfileModal({
					show: true,
				})
			);
			dispatch(setDataPage(text));
		}
	};

	const showModal = () => {
		dispatch(
			setBalanceModal({
				show: true,
			})
		);
	};
	return (
		<header className={styles.header}>
			<div className={styles.header__centralized_container}>
				<div className={styles.header__left_side}>
					<div className={styles.header__services}>
						<LinksServices />
					</div>
					<div className={styles.header__logo}>
						<GetterIcon />
						<span>прием показаний счетчиков</span>
						<p>|</p>
						<p>Kloud.one</p>
					</div>
				</div>
				<div className={styles.header__right_side}>
					<Profile />
					<p>{profile?.display_name ?? ''}</p>
					<LogoutButton />
				</div>
			</div>
			<div className={styles.navbar}>
				<div className={styles.navbar_header}>
					<div className={styles.navbar_header__container}>
						<NavMenuButton
							text="Счетчики"
							page={page.data}
							onClick={onSetViewMeters}
							icon={<Counter />}
						/>
						<NavMenuButton
							text="Настройки подключения"
							page={page.data}
							onClick={showSettingsProfileModal}
							icon={<Settings />}
						/>
						<NavMenuButton
							text="Настройки сценария"
							page={page.data}
							onClick={showSettingsModal}
							icon={<Play />}
						/>
						<NavMenuButton
							text="Журнал"
							page={page.data}
							onClick={onSetViewCalls}
							icon={<Log />}
						/>
					</div>
					<div className={styles.navbar_header__balance}>
						<BalanceButton
							balance={profile?.recognize_key == 'getter'
							? returnBalanceTariff()
							: `${Math.ceil(Number(seconds) / 60)}`
							}
							text="минут"
							onClick={showModal}
							icon={<Wallet />}
							arrow={<ArrowBottomIcon />}
						/>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
